<div *ngIf="reportType === 'Briefly-Officer'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ===== HEADER TABLE ===== -->
    <table style="width: 100%; border-collapse: collapse; border: 1px solid black; background-color: #f8f9fa; margin-top: 1rem;">
      
      <!-- Main Header Row -->
      <tr style="font-size:18px; font-weight:bold;">
        <th colspan="1" style="border:none; text-align:center; padding:8px; border-bottom: 1px solid black;">
          हिंदुस्तान प्रकाशन संस्था 
        </th>
        <th colspan="2" style="border:none; text-align:center; padding:8px; border-bottom: 1px solid black;">
          Book Credit Note Report
        </th>
        <th colspan="1" style="border:none; text-align:right; padding:8px; border-bottom: 1px solid black;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- Sub Header Row -->
      <tr style="font-size:16px; font-weight:bold;">
        <th colspan="1" style="border:none; text-align:center; padding:8px;">
विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="2" style="border:none; text-align:center; padding:8px;">
          Office Rep -Briefly
        </th>
        <th colspan="1" style="border:none; text-align:right; padding:8px;">
          From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

    </table>

    <!-- ===== MAIN DATA TABLE ===== -->
    <table class="table table-bordered table-sm w-100"
           style="border-collapse: collapse; table-layout: fixed; border:1px solid black; margin-top: 0;">

      <!-- Column Header -->
      <thead class="text-center align-middle">
        <tr style="font-weight:bold;">
          <th colspan="3" style="border:1px solid black; padding:8px; text-align:center;">
            Office Representative Name
          </th>
          <th colspan="1" style="border:1px solid black; padding:8px; text-align:center;">
            Credit note Amount
          </th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>

        <!-- One row per office representative -->
        <tr *ngFor="let group of groupedData">
          <td colspan="3" style="border:1px solid black; padding:8px; text-align:left;">
            {{ group.office_rep_name }}
          </td>
          <td colspan="1" style="border:1px solid black; padding:8px; text-align:right;">
            {{ group.totalAmount  }}
          </td>
        </tr>

      </tbody>

      <!-- ================= FOOTER ================= -->
      <tfoot>
        <!-- Grand Total -->
        <tr style="background-color: #c8753f; font-weight:bold;">
          <td colspan="3" style="border:1px solid black; padding:8px; text-align:right;">
            Grand Total:
          </td>
          <td colspan="1" style="border:1px solid black; padding:8px; text-align:right;">
            {{ grandTotal }}
          </td>
        </tr>
      </tfoot>

    </table>

    <!-- BUTTONS -->
    <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4 mt-3">
      <button class="btn btn-primary" (click)="exportExcel('BookCreditNoteOfficerReport')">Export</button>
      <button class="btn btn-primary" (click)="printPageA4()">Print</button>
      <button class="btn btn-secondary" mat-dialog-close>Close</button>
    </div>

  </div>
</div>